module.exports = "../dist/frontend/icons/logo/white.svg?5529988c479d8ef1bc59c133d5536e42";